import React from 'react';
import { Box, Palette, Typography } from '@mui/material';
import { InformationChip, LinkButton } from '@europrocurement/flexy-components';

interface PrescripteurOffreSectionProps {
    prescripteur: {
        id: number;
        raisonSociale: string;
        codeComptable: string;
        urlToDetails?: string;
    };
    offre: { libelle: string };
    palette: Palette;
}

export const PrescripteurOffreSection: React.FunctionComponent<PrescripteurOffreSectionProps> =
    function ({ prescripteur, offre, palette }) {
        return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '16px' }}>
                <Typography
                    variant="l2dbodys"
                    color="text.gris60"
                >
                    Prescripteur:
                </Typography>

                {prescripteur.urlToDetails ? (
                    <LinkButton
                        target="_blank"
                        to={prescripteur.urlToDetails}
                        onClick={() => {}}
                        wrapperSx={{
                            backgroundColor: palette.grey[100],
                            '&:hover': {
                                backgroundColor: palette.grey[200],
                                color: palette.grey[900],
                            },
                            fontWeight: 500,
                            color: palette.grey[700],
                            padding: '6px 8px',
                        }}
                        label={prescripteur.raisonSociale}
                    />
                ) : (
                    <Typography
                        variant="l2dbodys"
                        color="text.gris70"
                        sx={{ fontWeight: 500 }}
                    >
                        {prescripteur.raisonSociale}
                    </Typography>
                )}

                <Typography
                    variant="l2dbodys"
                    color="text.gris50"
                >
                    ({prescripteur.codeComptable})
                </Typography>

                <InformationChip
                    label={<Typography variant="l2dbodys">{offre?.libelle}</Typography>}
                    icon={['fasl', 'star-circle']}
                    color={palette.grey[600]}
                />
            </Box>
        );
    };
